// src/shared_new/modules/SelectedValuesPanel.jsx
import React from "react";
import { Box, useTheme } from "@mui/material";
import SelectedValueModule from "./SelectedValueModule";

/**
 * SelectedValuesPanel Component
 *
 * Displays a panel of selected values using SelectedValueModule components
 * Used in forms to show user selections as they progress through steps
 *
 * @param {Array} values - Array of {label, value} objects to display
 * @param {object} sx - Additional styles
 */
export default function SelectedValuesPanel({ values = [], sx = {} }) {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {};

  return (
    <Box
      sx={{
        p: 1.5,
        bgcolor: perlColors.surface || "rgba(255, 255, 255, 0.04)",
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
        ...sx,
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          pr: 0.5,
        }}
      >
        {values.map((item, index) => (
          <SelectedValueModule key={index} label={item.label} value={item.value} />
        ))}
      </Box>
    </Box>
  );
}
